module.exports = __webpack_public_path__ + "img/web.c94173db.png";